/* =====================================================================
   HERMES — Gafas Antiluz Vista Lejana (Homeira Colombia) — brief Id 10
   PRIMER PRODUCTO CON 2 VARIANTES DEL PIPELINE.

   Nucleo nuevo: SELECTOR DE AUMENTO sincronizado en 3 grupos (hero /
   seccion aumento / CTA final) + CART PRIMER POR VARIANTE (regla 5.R):
   el carrito siempre queda con la variante SELECCIONADA y solo esa
   (la otra se pone a quantity 0 — nunca se acumulan las dos).

   Resto del chassis CO vigente: gate de animaciones (hm-gaf--js), CTAs
   hero/sticky = anchors puros, CTA final = boton real con hook classes,
   kill del floating Releasit (5.B), skin del submit del modal (5.C),
   deteccion desktop triple (regla 2).
   ===================================================================== */
(function () {
  "use strict";

  var root = document.getElementById("hm-gaf-root");
  if (!root) return;

  /* Gate JS: los estados iniciales ocultos solo aplican con esta clase */
  root.classList.add("hm-gaf--js");

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Desktop detection (regla 2 — triple check) ---------------- */
  function isDesktopLike() {
    try {
      var wide = window.matchMedia("(min-width: 1024px)").matches;
      var hoverFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      var noTouch = !("ontouchstart" in window) && navigator.maxTouchPoints === 0;
      return wide || hoverFine || noTouch;
    } catch (e) { return false; }
  }

  var overlay = document.querySelector('.hm-gaf-overlay[data-mode="desktop"]');
  if (root.classList.contains("hm-gaf--desktop-block") && isDesktopLike() && overlay) {
    overlay.style.display = "flex";
  }

  /* =====================================================================
     ESTADO DE VARIANTE (fuente unica de verdad del aumento seleccionado)
     ===================================================================== */
  var ALL_VARIANTS = (root.getAttribute("data-all-variants") || "")
    .split(",")
    .map(function (s) { return s.trim(); })
    .filter(Boolean);

  var state = {
    variantId: String(root.getAttribute("data-variant-id") || ALL_VARIANTS[0] || ""),
    word: ""
  };

  var opts = Array.prototype.slice.call(root.querySelectorAll(".hm-gaf-aum__opt"));
  var rollInner = document.getElementById("hm-gaf-roll-inner");
  var stickyAum = document.getElementById("hm-gaf-sticky-aum");
  var visibleInput = document.getElementById("hm-gaf-visible-id");
  var nativeInput = document.getElementById("hm-gaf-native-id");

  function variantIndex(id) {
    for (var i = 0; i < ALL_VARIANTS.length; i++) {
      if (ALL_VARIANTS[i] === String(id)) return i;
    }
    return 0;
  }

  function paintVariant(id, animate) {
    id = String(id);
    state.variantId = id;

    opts.forEach(function (b) {
      var on = b.getAttribute("data-variant") === id;
      b.setAttribute("aria-checked", on ? "true" : "false");
      if (on) {
        state.word = b.getAttribute("data-word") || "";
        if (animate && !prefersReduced) {
          b.classList.remove("is-sweep");
          /* reflow para reiniciar la animacion de refraccion */
          void b.offsetWidth;
          b.classList.add("is-sweep");
        }
      }
    });

    /* Digit roll del aumento seleccionado */
    if (rollInner) {
      var slot = rollInner.querySelector(".hm-gaf-roll__slot");
      var h = slot ? slot.offsetHeight : 62;
      rollInner.style.transform = "translateY(-" + variantIndex(id) * h + "px)";
    }

    if (stickyAum && state.word) stickyAum.textContent = "Aumento " + state.word;

    /* Inputs de los dos forms (visible + nativo oculto) */
    if (visibleInput) visibleInput.value = id;
    if (nativeInput) nativeInput.value = id;
    root.setAttribute("data-variant-id", id);

    /* Releasit PageFly mode: SIEMPRE una sola variante, la seleccionada */
    try {
      var arr = window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS;
      if (arr && typeof arr.length === "number") {
        arr.length = 0;
        arr.push(parseInt(id, 10));
      } else {
        window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [parseInt(id, 10)];
      }
    } catch (e) {}
  }

  /* Pintado inicial (sin animacion) */
  paintVariant(state.variantId, false);

  opts.forEach(function (b) {
    b.addEventListener("click", function () {
      var id = b.getAttribute("data-variant");
      if (!id || id === state.variantId) return;
      paintVariant(id, true);
      /* Si el carrito ya fue cebado, reemplazar el item por el nuevo aumento */
      if (cartPrimed) prime("variant-change", true);
    });
  });

  /* =====================================================================
     CART PRIMER POR VARIANTE (regla 5.R + caso 2 variantes)
     Releasit CO arma la orden desde el CARRITO. El modo PageFly abre el
     modal pero NO agrega el item. Aqui garantizamos que al abrirse el
     modal el carrito contenga EXACTAMENTE la variante seleccionada:
       1) GET /cart.js
       2) toda linea de OTRA variante de este producto -> quantity 0
       3) si la seleccionada no esta -> POST /cart/add.js
     ===================================================================== */
  var cartPrimed = false;
  var priming = false;
  var lastPrime = 0;
  var lastPrimedVariant = "";
  /* Cuando la orden ya se envio, Releasit vacia el carrito (cart/clear.js).
     A partir de ese momento el primer se apaga: no debe volver a meter el
     item en el carrito del cliente despues de comprar. */
  var orderSent = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    });
  }

  function prime(reason, force) {
    if (!window.fetch || !state.variantId) return;
    if (orderSent) return;
    if (priming) return;
    if (!force && lastPrimedVariant === state.variantId && Date.now() - lastPrime < 4000) return;
    priming = true;
    var target = state.variantId;

    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var stale = items.filter(function (it) {
          return ALL_VARIANTS.indexOf(String(it.variant_id)) > -1 && String(it.variant_id) !== target;
        });
        var present = items.some(function (it) {
          return String(it.variant_id) === target && it.quantity > 0;
        });

        /* 2) quitar las lineas de la otra variante, una por una */
        var chain = Promise.resolve();
        stale.forEach(function (it) {
          chain = chain.then(function () {
            return postJSON("/cart/change.js", { id: it.key, quantity: 0 });
          });
        });

        /* 3) agregar la seleccionada si falta */
        return chain.then(function () {
          if (present) return null;
          return postJSON("/cart/add.js", { id: parseInt(target, 10), quantity: 1 });
        });
      })
      .then(function () {
        priming = false;
        cartPrimed = true;
        lastPrimedVariant = target;
        lastPrime = Date.now();
        try { console.info("[hm-gaf] cart primed -> " + target + " (" + reason + ")"); } catch (e) {}
      })
      .catch(function () { priming = false; });
  }

  /* Trigger 1: click en el area del CTA final (donde vive el boton Releasit) */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest("#hm-gaf-cod-slot-final")) prime("cta-final");
  }, true);

  /* Trigger 2: el modal COD de Releasit se abre (cualquier camino) */
  if (window.MutationObserver) {
    var moModal = new MutationObserver(function () {
      var m = document.getElementById("_rsi-cod-form-modal");
      if (m && m.className.indexOf("open") > -1) prime("modal-open");
    });
    moModal.observe(document.body || document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["class"]
    });
  }

  /* Trigger 3 (backstop): click/tap en el submit del modal */
  function submitBackstop(e) {
    var t = e.target;
    if (t && t.closest && t.closest('#_rsi-cod-form-modal [class*="submit"], #_rsi-cod-form-modal button[type="submit"]')) {
      prime("submit");
      /* Tras el envio, Releasit crea la orden y limpia el carrito: apagamos
         el primer para no re-agregar el producto despues de comprar. */
      setTimeout(function () { orderSent = true; }, 2500);
    }
  }
  document.addEventListener("mousedown", submitBackstop, true);
  document.addEventListener("touchstart", submitBackstop, true);

  /* =====================================================================
     ANIMACIONES
     ===================================================================== */

  /* --- "lens focus": entra desenfocado y enfoca (animacion NUEVA) --- */
  (function lensFocus() {
    var targets = root.querySelectorAll("[data-focus], .hm-gaf-rail__item");
    if (!("IntersectionObserver" in window) || !targets.length) {
      Array.prototype.forEach.call(targets, function (t) { t.classList.add("hm-gaf--visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("hm-gaf--visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -40px 0px" });
    Array.prototype.forEach.call(targets, function (t) { io.observe(t); });
  })();

  /* --- Carrusel scroll-snap: barra de progreso (animacion NUEVA) --- */
  (function momRail() {
    var track = document.getElementById("hm-gaf-mom-track");
    var fill = document.getElementById("hm-gaf-mom-fill");
    if (!track || !fill) return;
    var slides = track.querySelectorAll(".hm-gaf-mom__slide").length || 1;
    fill.style.width = (100 / slides) + "%";
    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        fill.style.transform = "translateX(" + (p * (slides - 1) * 100) + "%)";
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ---------------- Sticky mobile CTA (IO dual: hero + CTA final) ---------------- */
  (function stickyCta() {
    var sticky = document.getElementById("hm-gaf-sticky");
    var hero = document.getElementById("hm-gaf-hero");
    var finalCta = document.getElementById("hm-gaf-final");
    if (!sticky || !hero) return;
    var heroVisible = true;
    var finalVisible = false;
    function sync() {
      if (!heroVisible && !finalVisible) sticky.classList.add("hm-gaf--show");
      else sticky.classList.remove("hm-gaf--show");
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { heroVisible = e.isIntersecting; sync(); });
    }, { threshold: 0 }).observe(hero);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; sync(); });
      }, { threshold: 0.1 }).observe(finalCta);
    }
  })();

  /* ---------------- Anti-spy layer ---------------- */
  (function antiSpy() {
    if (!root.classList.contains("hm-gaf--anti-spy")) return;

    function trigger() {
      if (!overlay) return;
      overlay.style.display = "flex";
      overlay.classList.add("hm-gaf-overlay--spy-active");
      root.classList.add("hm-gaf--spy-caught");
    }

    document.addEventListener("contextmenu", function (e) { e.preventDefault(); trigger(); });

    document.addEventListener("keydown", function (e) {
      var k = e.key ? e.key.toLowerCase() : "";
      var blocked =
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c"].indexOf(k) > -1) ||
        (e.ctrlKey && ["u", "s", "p"].indexOf(k) > -1);
      if (blocked) { e.preventDefault(); trigger(); }
    });

    root.querySelectorAll("img, video").forEach(function (el) {
      el.setAttribute("draggable", "false");
      el.addEventListener("dragstart", function (e) { e.preventDefault(); });
    });

    var threshold = 160;
    setInterval(function () {
      var widthDelta = window.outerWidth - window.innerWidth;
      var heightDelta = window.outerHeight - window.innerHeight;
      if (widthDelta > threshold || heightDelta > threshold) trigger();
    }, 1500);

    try { console.clear(); } catch (e) {}
  })();

  /* ---------------- QR + WhatsApp self-share (overlay desktop) ---------------- */
  (function overlayShare() {
    var qrBox = document.getElementById("hm-gaf-qr");
    var urlBox = document.getElementById("hm-gaf-url");
    var waLink = document.getElementById("hm-gaf-whatsapp");
    if (!qrBox && !urlBox && !waLink) return;
    var pageUrl = window.location.href;
    if (qrBox) {
      var img = document.createElement("img");
      img.alt = "QR";
      img.src = "https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=" + encodeURIComponent(pageUrl);
      qrBox.appendChild(img);
    }
    if (urlBox) urlBox.textContent = pageUrl.replace(/^https?:\/\//, "");
    if (waLink) waLink.href = "https://wa.me/?text=" + encodeURIComponent("Mira esto: " + pageUrl);
  })();

  /* ---------------- Kill Releasit floating (regla 5.B) ---------------- */
  (function killFloating() {
    var tries = 0;
    var maxTries = 48; /* 24s @ 500ms */
    var iv = setInterval(function () {
      tries++;
      document.querySelectorAll('._rsi-buy-now-button-floating, [class*="_rsi-buy-now"][class*="floating"], [class*="_rsi-floating"], .rsi_floating, #floatingBuyNowButton').forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("opacity", "0", "important");
        el.style.setProperty("pointer-events", "none", "important");
      });
      if (tries >= maxTries) clearInterval(iv);
    }, 500);
  })();

  /* ---------------- Releasit submit skin (regla 5.C, vence inline styles) ---------------- */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el) return;
      el.style.setProperty("background", "linear-gradient(135deg, #7A6FE0, #5A4FC4)", "important");
      el.style.setProperty("color", "#ffffff", "important");
      el.style.setProperty("border-radius", "999px", "important");
      el.style.setProperty("border", "none", "important");
      el.style.setProperty("font-weight", "700", "important");
      el.style.setProperty("min-height", "54px", "important");
      el.style.setProperty("width", "100%", "important");
    }
    function sweep() {
      document.querySelectorAll('[class*="_rsi"][class*="submit"], [class*="_rsi-cod-form"] button[type="submit"], [class*="_rsi-modal"] button[type="submit"]').forEach(skin);
      /* El boton replace-in-place de Releasit llega con estilos INLINE verdes:
         solo se vence pisandolos por JS (el CSS de la landing pierde). */
      var slot = document.getElementById("hm-gaf-cod-slot-final");
      if (slot) {
        slot.querySelectorAll('#_rsi-buy-now-button-overwrite, [id*="_rsi-buy-now-button"]').forEach(function (el) {
          skin(el);
          el.style.setProperty("box-shadow", "0 16px 34px -12px rgba(90,79,196,0.8)", "important");
          el.style.setProperty("font-size", "1rem", "important");
          el.style.setProperty("outline", "none", "important");
          el.querySelectorAll("*").forEach(function (c) {
            c.style.setProperty("color", "#ffffff", "important");
            if (c.tagName === "svg" || c.tagName === "SVG") c.style.setProperty("fill", "#ffffff", "important");
          });
        });
      }
    }
    sweep();
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(sweep);
      mo.observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      sweep();
      if (tries >= 80) clearInterval(iv); /* ~40s */
    }, 500);
    document.addEventListener("click", function () { setTimeout(sweep, 60); });
  })();
})();
